'use client';

import { useMemo } from 'react';
import { useBannerService } from './useBannerService';
import { getActiveBanners } from '@/utils/domain/banner/getActiveBanners';

/**
 * Hook to get active banners for a specific location
 * @param location - Page location path, defaults to '/' for home page
 */
export const useActiveBanners = (location = '/') => {
  const { useGetBanners } = useBannerService();
  const { data } = useGetBanners({ location });

  return useMemo(() => getActiveBanners(data?.banners), [data]);
};
